<h1 mat-dialog-title>Filter Calendar View</h1>
<mat-dialog-content>
  <form mat-form [formGroup]="form">
  <h2 style="color: black; margin-bottom: 10px;">Topics</h2>

  <mat-checkbox (change)="toggleAllTopics($event)" [formControl]="selectAll" ngDefaultControl><strong>View all topics</strong></mat-checkbox>
  <div style="columns: 2;">
    <ng-container formArrayName="topics">
      <div *ngFor="let topic of data.allTopicGroups; let i = index">
         <mat-checkbox [formControlName]="i" (change)="updateSelectedTopicGroups()">
           {{topic.name}}
         </mat-checkbox>
      </div>
    </ng-container>
  </div>

  <h2 style="color: black; padding-bottom: 5px;">Countries</h2>
  <app-country-multi-select
    class="calendarfilter__countries"
    [countries]="data.allCountries"
    [(ngModel)]="data.selectedCountries"
    [ngModelOptions]="{standalone: true}"
    [label]="'Select Countries'">
  </app-country-multi-select>
</form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
  <button mat-flat-button color="accent" [mat-dialog-close]="data" cdkFocusInitial>Apply Filters</button>
</mat-dialog-actions>
